import { useMemo } from 'react';
import { isEmpty } from 'ramda';
import { useI18n } from '@namespace/i18n';
import { IGamesCategory, IGamesProviderNormalised } from '../../types';

interface BreadcrumbItem {
  label: string;
  path: string;
}

export const useBreadCrumbsItems = () => {
  const { t } = useI18n();

  const generateBreadCrumbsItems = useMemo(() => {
    return (
      category: Partial<IGamesCategory>,
      provider: Partial<IGamesProviderNormalised>,
      casinoRoute: string,
      lobbyLabel: string = ''
    ): BreadcrumbItem[] => {
      const { origin } = window.location;
      let links: BreadcrumbItem[] = [
        {
          label: lobbyLabel,
          path: `${origin}${casinoRoute}`
        }
      ];

      if (!isEmpty(category) && isEmpty(provider)) {
        const { id: categoryId, title: categoryTitle } = category;
        links = [
          ...links,
          {
            label: t(categoryTitle!),
            path: `${origin}${casinoRoute}/${categoryId}`
          }
        ];
      }

      if (!isEmpty(provider)) {
        const { id: providerId, providerName: providerTitle } = provider;
        const { id: categoryId, title: categoryTitle } = category;
        links = [
          ...links,
          {
            label: `${t(providerTitle!)}${categoryTitle ? `, ${t(categoryTitle)}` : ''}`,
            path: `${origin}${casinoRoute}/${providerId}${categoryId ? `/${categoryId}` : ''}`
          }
        ];
      }

      return links;
    };
  }, [t]);

  return generateBreadCrumbsItems;
};
